import { AppSettingsContainer } from "UI/UI/DefaultInterface/ApplicationSettings/AppSettingsContainer";
import { IFRMParams } from "../Controls/FormParameters";
import { FormManager } from "../FormManager/IFormManager";
import { MessageWindow } from "../MessageWindow";
import { IWindowable } from "../UIManagerInterfaces";
import { ISettingWindowFormBuilder } from "./ISettingWindowFormBuilder";
import { ProgrammableForm } from "./ProgrammableForm";

export class SettingWindowFormBuilder implements ISettingWindowFormBuilder {
    constructor() {
        // Prázdný konstruktor
    }

    /**
   * Sestaví formulář pro zobrazení Nastavení aplikace
   * @param parametricData Volitelné parametry formuláře
   */
    public async build(msgWindow: MessageWindow, parametricData: IFRMParams): Promise<IWindowable> {
        const formCode = "dynamicFrm.settingWindow";
        const formInstanceId = FormManager.instance.createFormInstanceId(formCode, parametricData);
        const form = new ProgrammableForm(formCode, formInstanceId, parametricData);

        form.getElement().innerHTML = await (await fetch("application-settings.html")).text();
        const element = form.getElement().querySelector("tsc-app-settings-container") as AppSettingsContainer;
        element.openerWindow = msgWindow;

        form.isModal = true;
        form.titleLocKey = "GUI-648803"; //Nastavení

        return form;
    }
}
